import React from "react";
import MeterDetailsView from "../../../../views/dashboard/meters/Details";

const MeterDetails = () => {
  return <MeterDetailsView />;
};

export default MeterDetails;
